import { LoadingIndicator } from 'components/LoadingIndicator';
import { Modal } from 'components/Modal/Modal';
import { DefaultECSegmentManager, ECSegmentManager } from 'core/ecSegment/ECSegmentManager';
import { useCallAPI } from 'hooks/useCallAPI';
import i18n from 'i18n';
import { useCallback } from 'react';

const ecSegmentManager: ECSegmentManager = new DefaultECSegmentManager();
export const DeleteECSegmentModal: React.FC<{
  selectedSegmentIds: string[];
  onClose: (needRefreshList: boolean) => void;
}> = ({
  selectedSegmentIds,
  onClose
}) => {

  const { loading, callAPIs } = useCallAPI();

  const deleteECSegments = useCallback(() => {
    callAPIs([() => ecSegmentManager.deleteECSegments(selectedSegmentIds)], () => {
      onClose(true);
    });
  }, [selectedSegmentIds, callAPIs, onClose]);

  const onCloseModal = useCallback(() => {
    onClose(false);
  }, [onClose]);

  return (
    <Modal
      title={i18n.t<string>('common.titles.hint')}
      primaryButton={{
        title: i18n.t<string>('common.buttons.delete'),
        callback: deleteECSegments
      }}
      secondaryButton={{
        title: i18n.t<string>('common.buttons.cancel'),
        callback: onCloseModal
      }}
      dismiss={onCloseModal}
    >
      {loading && <LoadingIndicator />}
      {i18n.t<string>('ecSegmentList.labels.deleteConfirm')}
    </Modal>
  );
};
